exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header[data-v-69be2135]{font-weight:300;border-top-left-radius:.25rem;border-top-right-radius:.25rem}", ""]);

// exports
